const colorSwatches = document.querySelectorAll('.ColorSwatchList input');
const sizeSwatches = document.querySelectorAll('.SizeSwatchList input');
let currentSelectedVariant = null;

// check if first selected variant is available, if not loop through variant to get one
if (!firstSelectedVariant.available) {
    let firstAvailableVariant = null;
    // Try to find the first available in current color
    if (colorSwatches) {
        firstAvailableVariant = variants.find((variant) => {
            return variant.option1 === firstSelectedVariant.option1 && variant.available;
        });
    } else {
        firstAvailableVariant = variants.find((variant) => {
            return variant.available;
        });
    }

    if (colorSwatches) {
        colorSwatches.forEach((swatch) => {
            if (swatch.value === firstAvailableVariant.option1) {
                swatch.click();
            }
        });
    }

    if (sizeSwatches) {
        sizeSwatches.forEach((swatch) => {
            if (swatch.value === firstAvailableVariant.option2) {
                swatch.click();
            }
        });
    }

    currentSelectedVariant = firstSelectedVariant;
} else {
    if (colorSwatches) {
        colorSwatches.forEach((swatch) => {
            if (swatch.value === firstSelectedVariant.option1) {
                swatch.click();
            }
        });
    }

    if (sizeSwatches) {
        sizeSwatches.forEach((swatch) => {
            if (swatch.value === firstSelectedVariant.option2) {
                swatch.click();
            }
        });
    }

    currentSelectedVariant = firstSelectedVariant;
}

// Check size availability for current color
function checkSizeForColor() {
    if (sizeSwatches) {
        let unavailableSizes = [];
        variants.forEach((variant) => {
            if (variant.option1 === currentSelectedVariant.option1 && !variant.available) {
                unavailableSizes.push(variant.option2);
            }
        });

        sizeSwatches.forEach((swatch) => {
            if (unavailableSizes.includes(swatch.value)) {
                swatch.disabled = true;
                swatch.classList.add('unavailable');
            } else {
                swatch.disabled = false;
                swatch.classList.remove('unavailable');
            }
        });
    }
}
checkSizeForColor();

// Check color availability for current size
function checkColorForSize() {
    if (colorSwatches) {
        let unavailableColors = [];
        variants.forEach((variant) => {
            if (variant.option2 === currentSelectedVariant.option2 && !variant.available) {
                unavailableColors.push(variant.option1);
            }
        });

        colorSwatches.forEach((swatch) => {
            if (unavailableColors.includes(swatch.value)) {
                swatch.disabled = true;
                swatch.classList.add('unavailable');
            } else {
                swatch.disabled = false;
                swatch.classList.remove('unavailable');
            }
        });
    }
}
checkSizeForColor();

document.addEventListener('variant:changed', (e) => {
    currentSelectedVariant = e.detail.variant;
    checkSizeForColor();
    checkColorForSize();
});